<template>
  <b-card>
    <div
      class="content-box"
      style="padding-top:0px;"
    >
      <div class="pieBox">
        <el-row align="center">
          <el-col
            :span="24"
            :md="6"
            class="titlecol"
          >
            <p>学校总岗位数量</p>
            <p>{{ jobNumber.jobNum }}</p>
          </el-col>
          <el-col
            :span="24"
            :md="6"
            class="titlecol"
          >
            <p>总岗位计划招聘人数合计</p>
            <p>{{ jobNumber.needNum }}</p>
          </el-col>
          <el-col
            :span="24"
            :md="6"
            class="titlecol"
          >
            <p>在岗总人数合计</p>
            <p>{{ jobNumber.studentNum }}</p>
          </el-col>
          <el-col
            :span="24"
            :md="6"
            class="titlecol"
          >
            <p>岗位空缺合计</p>
            <p v-if="jobNumber.needNum">
              {{ jobNumber.needNum-jobNumber.studentNum }}
            </p>
          </el-col>
        </el-row>
      </div>
      <div class="pieBox">
        <el-row>
          <el-col :span="24" :md="12" class="mb-1">
            <unitSearch style="width: 100%" @submitUnitId="submitUnitId" />
          </el-col>
          <el-col
            :span="24"
            :md="12"
            align="right"
            class="mb-1"
          >
            <el-button
              type="primary"
              class="ml-1"
              @click="exportStu"
            >导出在岗学生</el-button>
            <el-button
              type="primary"
              class="ml-1"
              @click="fileDown"
            >下载统计</el-button>
          </el-col>
        </el-row>
        <el-table
          :data="unitTableList"
          class="responsive"
        >
          <el-table-responsive-column
            prop="date"
            label="序号"
            width="180"
          >
            <template slot-scope="scope">
              {{ scope.$index+1 }}
            </template>
          </el-table-responsive-column>
          <el-table-responsive-column
            prop="name"
            label="用工单位名称"
          />
          <el-table-responsive-column
            prop="jobNum"
            label="岗位数"
          />
          <el-table-responsive-column
            prop="studentNum"
            label="在岗学生合计"
          />
          <el-table-responsive-column
            label="操作"
            width="180"
          >
            <template slot-scope="scope">
              <el-button type="text">
                <router-link
                  style="color:#409EFF;text-decoration: none;"
                  :to="{name:'DataCountDeatail',query:{
                    id:scope.row.id,
                    unitName:scope.row.name,
                    userIsChenk:userIsChenk
                  }}"
                >查看详情</router-link>
              </el-button>
            </template>
          </el-table-responsive-column>
        </el-table>
        <el-pagination
          style="margin:0 auto;text-align: center;"
          :current-page="page+1"
          :page-size="size"
          layout="total, prev, pager, next"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </b-card>
</template>

<script>
import { dataCountService } from '@/api/index'
import unitSearch from '@/components/UnitSearch.vue'
import { downLoadFile } from '@/tool/utils'

export default {
  name: 'Index',
  components: { unitSearch },
  data() {
    return {
      userIsChenk: false,
      jobNumber: {},
      unitTableList: [

      ],
      page: 0,
      size: 20,
      total: 0,
      unitId: this.$route.params.id ? this.$route.params.id : null,
    }
  },
  watch: {
    unitId() {
      this.page = 0
      this.queryUnitList()
    },
  },
  created() {
    this.queryJobNumber()
    this.queryUnitList()
  },
  methods: {
    // 查询岗位人数
    queryJobNumber() {
      dataCountService()._jobQueryNumber(
        {
          unitId: null,
        },
      ).then(res => {
        if (res.status) {
          // res.data.forEach(item => {
          //   if (item.jobType === 1) {
          //     this.jobNumber.fixedNumber = item.jobNum
          //     this.jobNumber.fixwdStudentNumber = item.studentNum
          //   } else {
          //     this.jobNumber.temporaryNumber = item.jobNum
          //     this.jobNumber.temporaryStudentNumber = item.studentNum
          //   }
          // })
          this.jobNumber = res.data
        }
      })
    },
    // 查询用工单位i列表
    queryUnitList() {
      dataCountService()._getUnitStatistics(
        {
          create_date: null,
          page: this.page,
          size: this.size,
          start: 0,
          unitId: this.unitId,
        },
      ).then(res => {
        this.unitTableList = []
        if (res.status && res.data) {
          this.unitTableList.push(...res.data.content)
          this.total = res.data.totalElements
        }
      })
    },
    submitUnitId(id) {
      if (id) {
        this.userIsChenk = true
      } else {
        this.userIsChenk = false
      }
      this.unitId = id
    },
    handleSizeChange(val) {
      this.size = val
      this.queryUnitList()
    },
    handleCurrentChange(val) {
      this.page = val - 1
      this.queryUnitList()
    },
    exportStu() {
      const params = {
        unitId: this.unitId,
      }
      const callBack = message => {
        if (!message) { // 下载成功
          this.$message.success('下载成功')
        } else { // 下载失败
          this.$alert(message, '下载失败', {
            confirmButtonText: '返回',
          })
        }
      }
      downLoadFile('/api/units/exportWorkingStudent', params, '在岗学生.xls', callBack)
    },
    fileDown() {
      const params = {
        create_date: null,
        start: 0,
        unitId: this.unitId,
      }
      const callBack = message => {
        if (!message) { // 下载成功
          this.$message.success('下载成功')
        } else { // 下载失败
          this.$alert(message, '下载失败', {
            confirmButtonText: '返回',
          })
        }
      }
      downLoadFile('/api/units/exportUnitStatistics', params, '统计表.xls', callBack)
    },
  },
}
</script>

<style scoped lang="less">
@import "../../styles/var";
.breadCream-box {
  .breadCream-box();
}
.titlecol {
  text-align: center;
  p:nth-child(1) {
    font-size: 14px;
    color: rgb(144, 147, 153);
  }
  p:nth-child(2) {
    font-size: 20px;
    color: #000;
  }
}
.content-box {
  width: calc(~"100% - 40px");
  margin: 0 auto;
  min-height: 840px;
  .pieBox {
    background-color: #fff;
    width: 100%;
    margin-bottom: 20px;
    padding: 20px 0 0 20px;
  }
  .barCharts {
    background-color: #fff;
    height: 500px;
    margin-bottom: 20px;
    padding: 20px 0 0 20px;
    width: calc(~"100% - 25px");
    float: left;
  }
}
</style>
